import {
  ChangeDetectorRef,
  Component,
  computed,
  ElementRef,
  HostBinding,
  inject,
  Input,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { Metadata } from 'src/app/models/record';
import { AnalyticsService } from 'src/app/_core/analytics/analytics.service';

@Component({
  selector: 'app-metadata-info',
  templateUrl: './metadata-info.component.html',
  styleUrls: ['./metadata-info.component.scss'],
})
export class MetadataInfoComponent implements OnInit, OnDestroy {
  private readonly analyticsService = inject(AnalyticsService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private textContentElement?: HTMLElement;
  private resizeObserver?: ResizeObserver;

  readonly contentExpanded = signal<boolean>(false);
  readonly contentExpandedLabel = computed(() => (this.contentExpanded() ? 'common.viewLess' : 'common.viewMore'));
  readonly showContentExpandButton = signal<boolean>(false);

  @ViewChild('textContent') set textContent(value: ElementRef<HTMLElement>) {
    this.textContentElement = value?.nativeElement;

    this.calculateElementHeight();
  }
  @Input() metadata: Metadata;
  @Input() enableFullWidth: boolean = false;

  @HostBinding('class.full-width')
  get hostClassFullWidth() {
    return this.enableFullWidth && this.metadata.values.some((v) => v.text.length > 50);
  }

  ngOnInit() {
    this.resizeObserver = new ResizeObserver(() => {
      this.calculateElementHeight();
    });

    this.resizeObserver.observe(document.documentElement);
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
  }

  updateAnalyticsOrigin() {
    this.analyticsService.searchPerformedOrigin = 'metadata';
  }

  private calculateElementHeight() {
    if (this.textContentElement) {
      const { height } = this.textContentElement.getBoundingClientRect();
      this.showContentExpandButton.set(height >= 120);
      this.changeDetectorRef.detectChanges();
    }
  }
}
